<template>
  <div class="checkout-headline">
    <h1>{{ $props.title }}</h1>
    <span>{{ $props.text }}</span>
  </div>
</template>

<script>
export default {
  name: 'checkout-headline',
  props: {
    title: String,
    text: String
  }
}
</script>

<style lang="scss" scoped>
.checkout-headline {
  margin-bottom: 2.4rem;
  padding: 0 2.4rem;

  @media (map_get($breakpoints, sm)) {
    margin-bottom: 4rem;
    padding: 0;
    text-align: center;
  }

  h1 {
    margin-bottom: 1.6rem;
    color: $black;
    font-size: 2rem;
    font-weight: 600;
    line-height: 1.6;

    @media (map_get($breakpoints, sm)) {
      margin-bottom: .8rem;
      font-size: 3.2rem;
      font-weight: 400;
      line-height: 1.3;
    }
  }

  span {
    color: $text;
    font-size: 1.4rem;

    @media (map_get($breakpoints, sm)) {
      font-size: 1.6rem;
    }
  }
}
</style>
